export default function PageHeader({ overline, title, body, image }) {
  return (
    <section
      className="relative bg-[#0A0A0A] text-[#F8F5F0] pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden"
      data-testid="page-header"
    >
      {image && (
        <>
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${image}')` }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/70 to-[#0A0A0A]/95" />
        </>
      )}
      <div className="relative container-mps">
        {overline && <div className="overline text-[#C9A96E] mb-5">{overline}</div>}
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight max-w-4xl leading-[1.02]">
          {title}
        </h1>
        {body && (
          <p className="mt-8 text-lg text-[#F8F5F0]/80 max-w-2xl leading-relaxed">{body}</p>
        )}
        <div className="gold-divider mt-12" />
      </div>
    </section>
  );
}
